export const LANGUAGES = [
    { label: 'English', code: 'en' },
    { label: 'العربية', code: 'ar' },
]
